import { Checkbox } from 'antd'
import React from 'react'

function BasicCheckbox() {
  return (
    <Checkbox className='auf-checkbox'>Checkbox</Checkbox>
  )
}

export default BasicCheckbox